function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var FactionBarTemplate = require('./factionbar.template');
var FactionBarOverlay = /*#__PURE__*/function () {
  function FactionBarOverlay(app, mod) {
    _classCallCheck(this, FactionBarOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
  }

  //
  // one or multiple factions
  //
  return _createClass(FactionBarOverlay, [{
    key: "setActive",
    value: function setActive() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      try {
        document.querySelectorAll('.factionbar-faction').forEach(function (el) {
          el.classList.remove('active');
        });
        if (typeof faction === 'string') {
          var obj = document.querySelector(".factionbar-faction.".concat(faction));
          if (obj) {
            obj.classList.add('active');
          }
        } else {
          if (Array.isArray(faction)) {
            for (var i = 0; i < faction.length; i++) {
              var _obj = document.querySelector(".factionbar-faction.".concat(faction[i]));
              if (_obj) {
                _obj.classList.add('active');
              }
            }
          }
        }
      } catch (err) {}
    }
  }, {
    key: "setInactive",
    value: function setInactive() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      try {
        if (typeof faction === 'string') {
          var obj = document.querySelector('.factionbar-faction.${faction}');
          if (obj) {
            obj.classList.add('active');
          }
        } else {
          if (Array.isArray(faction)) {
            for (var i = 0; i < faction.length; i++) {
              var _obj2 = document.querySelector(".factionbar-faction.".concat(faction[i]));
              if (_obj2) {
                _obj2.classList.add('active');
              }
            }
          }
        }
      } catch (err) {}
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.mod.game.players.length == 2) {
        return;
      }
      if (this.mod.game.state.players.length == 2) {
        return;
      }
      if (this.visible) {
        return;
      }
      var his_self = this.mod;
      this.app.browser.addElementToSelector(FactionBarTemplate());
      var factions = ['ottoman', 'hapsburg', 'england', 'france', 'papacy', 'protestant'];
      for (var z = 0; z < factions.length; z++) {
        var active_faction = '';
        if (this.mod.returnPlayerCommandingFaction(factions[z]) === this.mod.game.player) {
          active_faction = '*';
        }
        var f = factions[z];
        this.app.browser.addElementToSelector("<div class=\"factionbar-faction ".concat(f, "\" id=\"").concat(f, "\">").concat(f).concat(active_faction, "</div>"), '.factionbar');
      }
      this.visible = true;
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var his_self = this.mod;
      var factions = ['ottoman', 'hapsburg', 'england', 'france', 'papacy', 'protestant'];
      for (var z = 0; z < factions.length; z++) {
        var f = factions[z];
        document.querySelector(".factionbar-faction.".concat(f)).onclick = function (e) {
          var f = e.currentTarget.id;
          if (his_self.returnPlayerOfFaction(f) === his_self.game.player) {
            var fhand_idx = his_self.returnFactionHandIdx(his_self.game.player, f);
            his_self.game.state.players_info[his_self.game.player - 1].active_faction = f;
            his_self.game.state.players_info[his_self.game.player - 1].active_faction_idx = fhand_idx;
            var c = his_self.game.deck[0].fhand[fhand_idx];
            his_self.deck_overlay.render('hand', c);
            return;
          } else {
            _this.mod.deck_overlay.render(f);
          }
        };
      }
    }
  }]);
}();
module.exports = FactionBarOverlay;